import { usePermissionStore } from "@/stores/usePermissionStore";
import { watchEffect } from "vue";

export default {
  install(app) {
    app.directive("can", {
      mounted(el, binding) {
        const store = usePermissionStore();
        const needed = String(binding.value || "").toLowerCase();

        el.__canStop = watchEffect(() => {
          if (store.loading) {
            el.style.display = "none";
            return;
          }
          const allowed = store.permissions.includes(needed);
          el.style.display = allowed ? "" : "none";
        });
      },
      updated(el, binding) {
        // dibiarkan; watchEffect akan merespon perubahan store
      },
      unmounted(el) {
        if (el.__canStop) {
          el.__canStop();
          delete el.__canStop;
        }
      },
    });
  },
};
